<template>
    <div v-if="!companyPools || operationLoading">
        <loader-dialog />
    </div>
    <div v-else>
        <Dialog v-model:visible="visible" :style="{ width: '550px' }" :header="'Configure Companies in Pool ' + pool.name" :modal="true" @hide="$emit('hide-dialog', true)">
            <PickList
                v-model="companyPools"
                listStyle="height:350px; overflow-y:auto"
                dataKey="id"
                @move-to-target="operateCompaniesPool($event, 'add')"
                @move-all-to-target="operateCompaniesPool($event, 'add')"
                @move-to-source="operateCompaniesPool($event, 'remove')"
                @move-all-to-source="operateCompaniesPool($event, 'remove')"
            >
                <template #sourceheader> Companies List</template>
                <template #targetheader> Companies in the Pool </template>
                <template #item="slotProps">
                    <div class="flex flex-wrap p-2 align-items-center gap-3">
                        <div class="flex-1 flex flex-column gap-2">
                            <span>{{ slotProps.item.name }}</span>
                        </div>
                    </div>
                </template>
            </PickList>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, onBeforeUnmount } from 'vue';
import { usePoolStore } from '../store';
import { storeToRefs } from 'pinia';
import { showToast } from '@/helpers/toast-handler';

const store = usePoolStore();
const { pool, companyPools } = storeToRefs(store);
const visible = ref(true);
const operationLoading = ref(false);

const pageList = 'companyPoolList';

onBeforeUnmount(async () => {
    await store.fetchAllPools(null, pageList);
});

const operateCompaniesPool = async (event, mode) => {
    operationLoading.value = true;
    const allItems = event.items;
    let companiesTransferred = 0;
    for (let i = 0; i < allItems.length; i++) {
        const response = mode === 'add' ? await store.addCompanyToPool(pool.value?.id, allItems[i].id) : await store.removeCompanyFromPool(pool.value?.id, allItems[i].id);
        if (response) {
            companiesTransferred++;
        }
    }
    if (allItems?.length === companiesTransferred) {
        const message = (companiesTransferred == 1 ? `${allItems[0].name}` : `${companiesTransferred}`) + (mode === 'add' ? ' added to the pool' : ' removed from the pool');
        showToast({ severity: 'success', summary: 'Success' }, message);
    }
    operationLoading.value = false;
};
</script>

<style>
.p-picklist-source-controls,
.p-picklist-target-controls {
    display: none;
}
</style>
